var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.invoice_id && Object.keys(_vm.invoice).length > 0)?_c('div',[_c('NewSale',{attrs:{"viewdata":_vm.invoice}})],1):_c('div',[_c('b-alert',{attrs:{"show":""}},[_vm._v("NO INVOICE TO LOAD")])],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a940ea6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sales/EditInvoiceWrapper.vue
// module id = null
// module chunks = 